import axios from "axios";

const axiosPublic = axios.create({
    baseURL: process.env.REACT_APP_API_URL || "http://localhost:8081",
    headers: {
        "Content-Type": "application/json"
    }
});

export default axiosPublic;
